import { useQuery } from '@tanstack/react-query';

import { venueGetShopifyStoreProductApi } from '../../../api/shopify/venueGetShopifyStoreProductApi';
import { VenueGetShopifyStoreProductFilter } from '../../../graphql/API';

export const useVenueGetShopifyStoreProductQuery = (filters: VenueGetShopifyStoreProductFilter) => {
  const { data, isFetching, isError, isLoading } = useQuery({
    queryKey: ['shopify-product-by-id', { ...filters }],
    queryFn: async ({ queryKey }) => {
      const [, filters] = queryKey as [string, VenueGetShopifyStoreProductFilter];

      return venueGetShopifyStoreProductApi(filters);
    },
    refetchOnWindowFocus: false,
    enabled: !!filters.productID,
  });
  return { data, isFetching, isError, isLoading };
};
